// Default State

const IS_LOCAL = location.href.indexOf('localhost') >= 0 || location.href.indexOf('192.168') >= 0;
const API_URL = 'http://dev-fifa18.devup.cc';

export const state = {
    currentId: 0,
    animatedLoad: false,
    animated: false,
    uiShow: false,
    handleBlock: true,
    popup: {name: false},
    urlRoot: IS_LOCAL ? API_URL : ''
};




// WEBPACK FOOTER //
// ./src/store/state.js